import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Send: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.7574 12.1077C22.7504 11.567 22.4333 11.0743 21.9406 10.8495L2.98892 2.12904C2.4792 1.89356 1.87686 1.98561 1.46127 2.36237C1.04469 2.74013 0.893418 3.32831 1.07696 3.86115L3.4288 10.6605L13.4163 12.2116L3.46365 13.9846L1.26307 20.8346C1.10198 21.3425 1.24109 21.8967 1.61932 22.2666C1.64039 22.2872 1.66143 22.3058 1.68248 22.3244C2.10732 22.6928 2.71058 22.7724 3.21693 22.5257L21.9707 13.3857C22.4563 13.1481 22.7634 12.6495 22.7574 12.1077Z"
      fill="currentColor"
    />
  </svg>
);
